import { render, staticRenderFns } from "./Corporates.vue?vue&type=template&id=b5354468&scoped=true"
import script from "./Corporates.vue?vue&type=script&lang=js"
export * from "./Corporates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5354468",
  null
  
)

export default component.exports